import styled, { css } from 'styled-components';

import { DESKTOP_WIDTH, HEADER_HEIGHT } from '~constant/layout';

import { LayoutProps } from '.';

export const S = {
  BodyContainer: styled.main<Pick<LayoutProps, 'noFullWidth' | 'noHeader'>>`
    width: 100%;
    margin: 0 auto;

    ${({ noHeader }) =>
      !noHeader &&
      css`
        margin-top: ${HEADER_HEIGHT}px;
      `}

    ${({ theme }) => theme.media.pc} {
      width: ${(props) => (props.noFullWidth ? `${DESKTOP_WIDTH}px` : '100%')};
    }
  `,
};
